import React from 'react';
import randomstring from 'uuid/v4';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import Attach from '@material-ui/icons/AttachFile';

import PeriodLabel from './PeriodLabel';


const flatNodes = (node, add) => {
    node.path = `${add}${node.nombre}`;
    let result = [node];
    if (node.hijos) {
        node.hijos.forEach((c) => (result = result.concat(flatNodes(c , add + ' '))));
    }
    return result;
};

class HistoricChart extends React.Component {

    state = {
        titulo: undefined,
        widget: undefined
    }


    static getDerivedStateFromProps(props, state) {
        const { widget } = props;
        if (widget !== state.widget) {

            console.log(widget);
            state.widget = widget;

            state.jerarquia = widget && widget.jerarquia && widget.jerarquia.length > 0 ? flatNodes(widget.jerarquia[0], '') : [];
            state.node = widget && widget.jerarquia && widget.jerarquia.length > 0 ? widget.jerarquia[0].id : undefined;
            state.sets = widget && widget.sets && Object.keys(widget.sets).map((i) => { return {id: i, nombre: widget.sets[i]}; });
            state.set = state.sets && state.sets.length > 0 ? state.sets[0].id : undefined;
            state.serie = state.set ? widget.series[state.set && state.node ? `${state.set}_${state.node}` : `${state.set}`] : undefined;
            console.log(state.serie, state.set, state.node, state.set && state.node ? `${state.set}_${state.node}` : `${state.set}`);
            state.showValue = state.serie && !state.serie.total ? true : false ;
            state.showRef = state.serie && state.serie.totalRef ? true : false;
            state.serieTotal = state.serie && state.serie.total ? state.serie.total : undefined;

            return state;
        }
        return null;
    }

    handleChange = (event) => {
        const { widget } = this.state;
        let estado = this.state;
        estado[event.target.name] = event.target.value;
        const serie = estado.set ? widget.series[estado.set && estado.node ? `${estado.set}_${estado.node}` : `${estado.set}`] : undefined;
        const serieTotal = serie && serie.total ? serie.total : undefined;
        const showValue = serie && !serie.total ? true : false ;
        const showRef = serie && serie.totalRef ? true : false;
        this.setState({ 
                        [event.target.nombre]: event.target.value,
                        serie: serie,
                        serieTotal: serieTotal,
                        showValue: showValue,
                        showRef: showRef
                     });
    };

    render() {
        const {intl} = this.props;
        const { widget, sets, set, jerarquia, node, serie, serieTotal, showValue, showRef } = this.state;

        return (<div className="flex_full_column  padding_12">
                    <div className="flex_auto_row width100">
                        <Attach className={'attachIcon'} onClick={this.props.onDownload(this.props.data)} />
                        <span className="flex_full_row center barlowcondensed_medium c_lipstick uppercase">
                            {widget.nombre}
                        </span>
                        <PeriodLabel {...this.props} />
                    </div>
                    <div className="flex_full_column margin_top_4 historic">
                        <div key={randomstring()} className="flex_auto_row margin_top_4 width100">
                            <div className="flex_full_row barlow_italic_medium c_bluish margin_right_12">
                                
                            </div>
                            <div className="flex_auto_row barlow_regular_smalltext c_bluish">
                                {showValue ? ' ' : '%'}
                            </div>
                            {showRef &&
                                <div className="flex_auto_row barlow_regular_smalltext c_bluish margin_left_12">
                                    {'ref.'}
                                </div>
                            }
                        </div>
                        {serie &&
                            serie.valores &&
                                    serie.valores.map((v) => {
                                        const percentage = Math.round(((v.y) / serieTotal) * 100);
                                        const text = showValue ? v.y : `${percentage}%`;
                                        return (<div key={randomstring()} className="row flex_auto_row margin_top_4 width100">
                                                    <div className="flex_full_row barlow_italic_medium c_purple margin_right_12">
                                                        {v.x}
                                                    </div>
                                                    <div className="flex_auto_row barlow_regular_smalltext c_slate">
                                                        {text}
                                                    </div>
                                                    {v.ref &&
                                                        <div className="flex_auto_row barlow_regular_smalltext c_slate">
                                                            {v.ref}
                                                        </div>
                                                    }
                                                </div>
                                                );
                                    })
                        }
                    </div>
                    <div className="margin_top_24 flex_auto_row width100" >
                        <FormControl className={'flex_full width100 barlow_italic_medium c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'widget_title_series' })}
                            </InputLabel>
                            <Select
                                native
                                value={set}
                                fullWidth
                                className="barlow_italic_medium"
                                onChange={this.handleChange}
                                inputProps={{ name: 'set', id: 'set' }}
                                >
                                    <option key={randomstring()} value={undefined} />
                                    {sets &&
                                        sets.length > 0 &&
                                        sets.map((s) => {
                                            return (
                                                <option key={randomstring()} value={s.id}>
                                                    {s.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    
                    {jerarquia &&
                        jerarquia.length > 0 &&
                        <div className="margin_top_8 flex_auto_row width100" >
                            <FormControl className={'flex_full width100 barlow_italic_medium c_slate'}>
                                <InputLabel htmlFor="age-native-simple">
                                    {intl.formatMessage({ id: 'process_local' })}
                                </InputLabel>
                                <Select
                                    native
                                    value={node}
                                    fullWidth
                                    className="barlow_italic_medium"
                                    onChange={this.handleChange}
                                    inputProps={{ name: 'node', id: 'node' }}
                                    >
                                        <option key={randomstring()} value={undefined} />
                                        {jerarquia &&
                                            jerarquia.length > 0 &&
                                            jerarquia.map((s) => {
                                                return (
                                                    <option key={randomstring()} value={s.id}>
                                                        {s.path}
                                                    </option>
                                                );
                                            })}
                                </Select>
                            </FormControl>
                        </div>
                    }
                    
                </div>

            );
    }
}


export default HistoricChart;


// WEBPACK FOOTER //
// ./src/components/complex/dashboard/types/HistoricChart.js